import React from "react";
import PropTypes from "prop-types";
import Strf from "shared/components/Strf";
import Str from "shared/components/Str";
import IntroIcon from "shared/components/svgs/intro.svg";

import "./index.scss";

const PhoneWallExplainer = ({ name }) => {
	return (
		<div className="messenger-phone-wall messenger-message-pane">
			<IntroIcon />
			<div className="messenger-phone-wall-title">
				<Strf vars={{ name }}>
					Write $name a message.
				</Strf>
			</div>
			<div className="messenger-phone-wall-body">
				<Str>
					Stand out from the crowd by responding to their profile.
				</Str>
			</div>
		</div>
	);
};

PhoneWallExplainer.propTypes = {
	name: PropTypes.string.isRequired,
};

export default PhoneWallExplainer;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/PhoneWallExplainer/index.jsx